<template>
    <ui-modal
        icon="fal fa-id-card"
        :title="titleActive"
        text="Crie, edite e remova os perfis dinâmicos dos usuários."
        :load-success="loader.modalSuccess"
        :load="loader.modalLoading"
        :name="modalName"
        brl-off
    >
        <template #left>
            <div class="left-body">
                <div v-for="(section, index) in menuModal" :key="`${section.title}-${index}`">
                    <h2 class="title">{{ section.title }}</h2>
                    <ul class="menu-left">
                        <li
                            v-for="(item, index) in section.data"
                            :key="`${item.id}-${item.title}-${index}`"
                            :class="{ active: item.active }"
                            @click="updateActiveMenuModal(item, menuModal)"
                        >
                            {{ item.title }}
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <template>
            <div v-show="loader.body" class="loading-area">
                <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
            </div>

            <div v-show="!loader.body" class="body-modal">
                <div v-show="viewActive == 'general'" class="view">
                    <ui-input
                        v-model="form.name"
                        placeholder="Digite o nome do Perfil Dimânico:"
                        label="Nome do Perfil:"
                        type="text"
                        maxlength="20"
                    />
                    <div v-if="form.name.length >= 20" class="warning">
                        <span >Este campo deve ter, no máximo, 20 caracteres.</span>
                    </div>
                </div>

                <div v-show="viewActive == 'enterprises'" class="view">
                    <ui-select-2
                        v-model="form.enterprises"
                        :data="options.enterprises"
                        label="Empreendimentos:"
                        item-label="name"
                        return-value="id"
                        multiple
                    />
                </div>

                <div v-show="viewActive == 'customized'" class="view">
                    <ui-select-2
                        v-model="form.customized"
                        :data="options.customized"
                        label="Permissões Customizadas:"
                        item-label="name"
                        return-value="name"
                        align="left"
                        add-selecteds
                        multiple
                    />
                </div>

                <div v-show="viewActive == 'marketing'" class="view">
                    <div class="bb-1px scroll scroll-color">
                        <ui-util-box-text-slot
                            v-for="(item, index) in form.marketing"
                            :key="`${item.id}-${index}`"
                            :title="item.name"
                            design="no-bb"
                        >
                            <ui-switch
                                v-model="form.marketing[index].checked"
                                :checked="form.marketing[index].checked"
                                design="xs"
                            />
                        </ui-util-box-text-slot>
                    </div>
                </div>

                <div v-show="viewActive == 'sales'" class="view">
                    <div class="bb-1px scroll scroll-color">
                        <ui-util-box-text-slot
                            v-for="(item, index) in form.sales"
                            :key="`${item.id}-${index}`"
                            :title="item.name"
                            design="no-bb"
                        >
                            <ui-switch
                                v-model="form.sales[index].checked"
                                :checked="form.sales[index].checked"
                                design="xs"
                            />
                        </ui-util-box-text-slot>
                    </div>
                </div>

                <div v-show="viewActive == 'products'" class="view">
                    <div class="bb-1px scroll scroll-color">
                        <ui-util-box-text-slot
                            v-for="(item, index) in form.products"
                            :key="`${item.id}-${index}`"
                            :title="item.name"
                            design="no-bb"
                        >
                            <ui-switch
                                v-model="form.products[index].checked"
                                :checked="form.products[index].checked"
                                design="xs"
                            />
                        </ui-util-box-text-slot>
                    </div>
                </div>

                <div v-show="viewActive == 'communication'" class="view">
                    <div class="bb-1px scroll scroll-color">
                        <ui-util-box-text-slot
                            v-for="(item, index) in form.communication"
                            :key="`${item.id}-${index}`"
                            :title="item.name"
                            design="no-bb"
                        >
                            <ui-switch
                                v-model="form.communication[index].checked"
                                :checked="form.communication[index].checked"
                                design="xs"
                            />
                        </ui-util-box-text-slot>
                    </div>
                </div>

                <div v-show="viewActive == 'points_club'" class="view">
                    <div class="bb-1px scroll scroll-color">
                        <ui-util-box-text-slot
                            v-for="(item, index) in form.points_club"
                            :key="`${item.id}-${index}`"
                            :title="item.name"
                            design="no-bb"
                        >
                            <ui-switch
                                v-model="form.points_club[index].checked"
                                :checked="form.points_club[index].checked"
                                design="xs"
                            />
                        </ui-util-box-text-slot>
                    </div>
                </div>

                <div v-show="viewActive == 'users'" class="view">
                    <div class="bb-1px scroll scroll-color">
                        <ui-util-box-text-slot
                            v-for="(item, index) in form.users"
                            :key="`${item.id}-${index}`"
                            :title="item.name"
                            design="no-bb"
                        >
                            <ui-switch
                                v-model="form.users[index].checked"
                                :checked="form.users[index].checked"
                                design="xs"
                            />
                        </ui-util-box-text-slot>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <ui-button design="md success" :disabled="!canSubmit" @click="submit"
            >Salvar Configurações</ui-button
            >
        </template>
    </ui-modal>
</template>
<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiInput, uiSelect2, uiSwitch } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'

	import { defaultMenuModal, menuDynamycModal } from './data'
	import { product, user } from '@/services/axios'

	const defaultForm = () => ({
		name: '',
		customized: [],
		enterprises: [],
		marketing: [],
		sales: [],
		products: [],
		communication: [],
		points_club: [],
		users: [],
	})

	const defaultOptions = () => ({
		permissions: [],
		enterprises: [],
		customized: [],
		marketing: [],
		sales: [],
		products: [],
		communication: [],
		points_club: [],
		users: [],
	})

	const defaultDisabled = () => ({})

	const defaultLoader = () => ({
		body: true,
		modalLoading: false,
		modalSuccess: false,
	})

	export default {
		name: 'configuration-user-dynamics-modal',

		components: {
			uiModal,
			uiButton,
			uiInput,
			uiSelect2,
			uiSwitch,
			uiLoadIndicator,
			uiUtilBoxTextSlot,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		props: {
			modalName: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				form: { ...defaultForm() },
				options: { ...defaultOptions() },
				disabled: { ...defaultDisabled() },
				loader: { ...defaultLoader() },
				menuModal: [...defaultMenuModal(menuDynamycModal)],
				data: {},
				oldForm: {},
			}
		},

		computed: {
			canSubmit() {
				return !this.loader.body && this.$mx_isFormChanged
			},

			viewActive() {
				const { value } = this.menuActive
				return value
			},

			menuActive() {
				let active = {}
				this.menuModal.forEach((section) => {
					const finded = section.data.find((item) => item.active) || null
					if (finded)
						active = {
							section: section.title,
							...finded,
						}
				})
				return active
			},

			titleActive() {
				const { section, title } = this.menuActive
				return `${section} - ${title}`
			},

			validateData() {
				return {
					name: this.form.name,
					permissions: [...this.form.customized],
					products: [...this.form.enterprises],
					settings: {
						marketing: this.checkArray(this.form.marketing),
						sales: this.checkArray(this.form.sales),
						products: this.checkArray(this.form.products),
						communication: this.checkArray(this.form.communication),
						points_club: this.checkArray(this.form.points_club),
						users: this.checkArray(this.form.users),
					},
				}
			},
		},

		created() {
			this.$root.$on('modal-open-' + this.modalName, async (data) => {
				this.reset()

				const [enterprises, permissions] = await Promise.all([
					this.getEnterprises(),
					this.getPermissionsList(),
				])

				this.options.enterprises = enterprises
				this.options.permissions = permissions

				this.options.marketing = this.getPermissions('marketing')
				this.options.sales = this.getPermissions('sales')
				this.options.products = this.getPermissions('products')
				this.options.communication = this.getPermissions('communication')
				this.options.points_club = this.getPermissions('points_club')
				this.options.users = this.getPermissions('users')

				this.data = data
				this.form.name = data.name
				const settings = data.settings

				this.options.customized = this.objToOptions(data.custom_permissions)
				this.form.customized = this.objectToArray(data.custom_permissions)
				this.form.marketing = this.checkList(settings.marketing, this.options.marketing)
				this.form.sales = this.checkList(settings.sales, this.options.sales)
				this.form.products = this.checkList(settings.products, this.options.products)
				this.form.communication = this.checkList(
					settings.communication,
					this.options.communication,
				)
				this.form.points_club = this.checkList(
					settings.points_club,
					this.options.points_club,
				)
				this.form.users = this.checkList(settings.users, this.options.users)
				this.form.enterprises = data.products_permissions

				this.loader.body = false
				this.$mx_copyOldForm()
			})
		},

		methods: {
			handleAction(action) {
				const tag = this.form
				this.$root.$emit(action, tag)
			},

			updateActiveMenuModal(item, menuModal) {
				menuModal.forEach((section) => {
					section.data.forEach((i) => {
						if (i.active) i.active = false
					})
				})
				item.active = true
			},

			getPermissions(permission) {
				return this.options.permissions.find((item) => item.id == permission).components
			},

			closeModal() {
				this.$root.$emit('modal-close-' + this.modalName)
				this.loader.body = true
			},

			selectedArray(selectList, value = 'id') {
				let list = []
				selectList.forEach((item) => {
					list.push(item[value])
				})
				return list
			},

			checkArray(checkList, value = 'id') {
				let list = []
				checkList.forEach((item) => {
					if (item.checked) list.push(item[value])
				})
				return list
			},

			objToOptions(object) {
				const list = []
				let id = 0
				Object.keys(object).forEach((item) => {
					list.push({
						id: id,
						name: item,
					})
					id++
				})
				return list
			},

			checkList(checkeds, list) {
				let checkList = []
				checkeds = checkeds || []
				list.forEach((item) => {
					checkList.push({
						...item,
						checked: checkeds.includes(item.id) || false,
					})
				})
				return checkList
			},

			objectToArray(object) {
				return [...new Set(Object.keys(object))]
			},

			reset() {
				this.form = { ...defaultForm() }
				this.loader = { ...defaultLoader() }
			},

			async getEnterprises() {
				try {
					return (await product.getProductWithoutAvailable()).data
				} catch (error) {
					return []
				}
			},

			async getPermissionsList() {
				try {
					return (await user.readPermissions()).data
				} catch (error) {
					return []
				}
			},

			async submit() {
				try {
					this.loader.modalLoading = true

					await user.updateDynamicUser(this.data.id, this.validateData)

					setTimeout(() => {
						this.$root.$emit('dynamic-user-list:update')
						this.loader.modalSuccess = true
						setTimeout(() => {
							this.closeModal()
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.modalSuccess = false
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
